import { render, staticRenderFns } from "./ProductTabs.vue?vue&type=template&id=39084c71&scoped=true&"
import script from "./ProductTabs.vue?vue&type=script&lang=js&"
export * from "./ProductTabs.vue?vue&type=script&lang=js&"
import style0 from "./ProductTabs.vue?vue&type=style&index=0&id=39084c71&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39084c71",
  null
  
)

export default component.exports